import { Reveal } from "./motion";

export const TheGoal = () => {
  return (
    <section className="bg-ink py-20 md:py-28" data-testid="the-goal-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <p className="mb-5 font-mono text-xs font-bold uppercase tracking-[0.22em] text-cyan">
              The question you are already asking
            </p>
            <h2 className="font-display text-4xl font-black uppercase leading-none tracking-tight text-white sm:text-5xl lg:text-6xl">
              So what is the goal?
            </h2>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-7">
            <p className="text-lg leading-relaxed text-white/70 md:text-xl">
              Not to meet everyone. Not to collect cards. Not to turn every conversation into a sale.
            </p>
            <p className="mt-6 border-l-4 border-acid pl-6 text-xl font-semibold leading-relaxed text-white md:text-2xl">
              Learn who they are, why they are there, and whether the relationship has somewhere to go.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
